/*
 * 权益页「NEW」角标 · 卡片新权益 / 版本对比 AI 行共用（设计稿 209-3778）
 * 样式内联自管，不依赖页面 scss，放进任意标签后即可。
 */
import React from 'react'

const STYLE: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  marginLeft: 6,
  padding: '0 5px',
  height: 15,
  lineHeight: '15px',
  borderRadius: 8,
  fontSize: 10,
  fontWeight: 500,
  color: '#fff',
  background: 'linear-gradient(90deg, #6a6cf9 0%, #3e9bfd 100%)',
  verticalAlign: 'middle',
  flexShrink: 0
}

export default function NewBadge() {
  return <span style={STYLE}>NEW</span>
}
